import React from 'react'
import styled from 'styled-components'
import { CardRow } from '../../../../../../generic/ui/CardRow'
import { Mono } from '../../../../../../generic/ui/Mono'
import { SwipeableListItem } from '../../../../../../generic/swipe/SwipeableListAdapter'
import { SwipeAction } from '../../../../../../generic/ui/SwipeAction'
import PackageBoxIcon from '../../../../../../generic/icons/IconLib/PackageBoxIcon'
import RulerIcon from '../../../../../../generic/icons/IconLib/RulerIcon'
import ScaleIcon from '../../../../../../generic/icons/IconLib/ScaleIcon'
import HashIcon from '../../../../../../generic/icons/IconLib/HashIcon'
import PencilIcon from '../../../../../../generic/icons/IconLib/PencilIcon'
import { ISortingLines } from '../../../../../../modules/API/Miun/models/sortingList'

interface Props {
    item: ISortingLines
    isLast?: boolean
    onEdit: (item: ISortingLines) => void
}

const LineCard: React.FC<Props> = ({ item, isLast = false, onEdit }) => {
    const quality = item.QualityDesc?.trim() ?? ''
    const size = item.SizeDesc?.trim() ?? ''
    const primary = `${quality} ${size}`.trim()
    const pack = item.Pack_Name?.trim() ?? ''

    return (
        <Wrapper>
            <SwipeableListItem
                swipeRight={{
                    content: (
                        <SwipeAction
                            variant='edit'
                            align='start'
                            icon={<PencilIcon />}
                            label='ערוך'
                        />
                    ),
                    action: () => onEdit(item),
                }}
                threshold={0.3}
            >
                <CardRow
                    $columns='minmax(0, 1fr) 4.5rem 5rem'
                    $mobileColumns='minmax(0, 1fr) 3.5rem 4.5rem'
                    $isLast={isLast}
                    $interactive
                    onClick={() => onEdit(item)}
                >
                    <CardRow.Cell>
                        <CardRow.Stack $gap='0.25rem'>
                            <CardRow.Line $gap='0.5rem'>
                                <SubIcon>
                                    <RulerIcon color='currentColor' size={14} />
                                </SubIcon>
                                <PrimaryName>{primary}</PrimaryName>
                            </CardRow.Line>
                            <CardRow.Line $gap='0.5rem'>
                                <SubIcon>
                                    <PackageBoxIcon color='currentColor' size={14} />
                                </SubIcon>
                                <SecondaryName>{pack}</SecondaryName>
                            </CardRow.Line>
                        </CardRow.Stack>
                    </CardRow.Cell>

                    <CardRow.Cell $align='center'>
                        <CardRow.Line $gap='0.25rem'>
                            <SubIcon>
                                <HashIcon color='currentColor' size={13} />
                            </SubIcon>
                            <Qty>{item.Qty}</Qty>
                        </CardRow.Line>
                    </CardRow.Cell>

                    <CardRow.Cell $align='center'>
                        <CardRow.Line $gap='0.25rem'>
                            <SubIcon>
                                <ScaleIcon color='currentColor' size={13} />
                            </SubIcon>
                            <Weight>{Math.round(item.WeightNeto)}</Weight>
                        </CardRow.Line>
                    </CardRow.Cell>
                </CardRow>
            </SwipeableListItem>
        </Wrapper>
    )
}

export default LineCard

const Wrapper = styled.div`
    width: 100%;
`

const SubIcon = styled.span`
    display: inline-flex;
    align-items: center;
    color: ${({ theme }) => theme.colors.ink3};
    flex-shrink: 0;
`

const PrimaryName = styled.span`
    font-size: ${({ theme }) => theme.text.md};
    color: ${({ theme }) => theme.colors.ink};
    font-weight: 500;
    font-family: ${({ theme }) => theme.fonts.sans};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: ${({ theme }) => theme.textMobile.md};
    }
`

const SecondaryName = styled.span`
    font-size: ${({ theme }) => theme.text.sm};
    color: ${({ theme }) => theme.colors.ink3};
    font-family: ${({ theme }) => theme.fonts.sans};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: ${({ theme }) => theme.textMobile.sm};
    }
`

const Qty = styled(Mono)`
    font-size: ${({ theme }) => theme.text.md};
    font-weight: 600;
    color: ${({ theme }) => theme.colors.ink};
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: ${({ theme }) => theme.textMobile.md};
    }
`

const Weight = styled(Mono)`
    font-size: ${({ theme }) => theme.text.md};
    font-weight: 600;
    color: ${({ theme }) => theme.colors.accentDeep};
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: ${({ theme }) => theme.textMobile.md};
    }
`
